module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-bodymatter element-type-chapter element-with-heading",
    attrs: {
      "id": "vol-1-chapter-9"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "vol-1-chapter-9-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Chapter 9")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "vol-1-chapter-9-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("I")]), _vm._v("’m on parade. The taxi door swings wide as I step out onto the pavement. The sea breeze hits my face and cuts through my clothes, the dampness of dusk feels cold against my skin. I asked the driver to pull up short of the rank, so I can enjoy the walk. My heels clip against the concrete, announcing my presence.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A gang of guys tumble out of a pub, blocking my path.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Wow!’ A short fat man shouts as he sees me stop in my tracks. ‘Ever so sorry, madam,’ he says with a wicked grin painted across his face. ‘Make way lads for the beautiful lady.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He bows from the waist and waves his arm in a wide arc, removing an imaginary hat. The others part to form a guard of honour. The thin red material of my dress is clinging to the contours of my body.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘After you,’ one of them says, his eyes giving everything away.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I lower my gaze in mock appreciation. ‘Thank you, boys.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I watch them feast their eyes as I sashay between them, each one getting a good eyeful. I walk away, the sway of my hips holding their attention as I go. One of them wolf whistles.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘If you fancy a lollypop later love, I’ve got something you could suck on,’ he calls out as the others dissolve onto bawdy laughter. Just the reaction I wanted. I love being on Parade.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("It’s relatively early and the bouncers on the door of the Purple Parrot, with their bursting shirts and fluorescent armbands, see me coming. The tall one nudges the wide one with amateur tattoos inked around his neck.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Evening,’ he grunts as I approach.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Hi.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The wide one opens the door with a sweep of his arm. He stands his ground and I have to brush against him to enter the club.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Have a good time,’ he says as the door whooshes shut behind me.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The place is all purple and red, with flashing lights and thumping music. A few tables are occupied with pretty couples while the bar is a crush of stag parties and hen dos. I head over to the stag party where a man is dressed in a pink tutu and body suit with bright yellow wellies. He’s wearing a red wig and pigtails and looks like he’s been on the beer for a week. The men around him look happy and full of shots. I push my way between them and place my hand on the bar; a barmaid appears out of nowhere.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘A large Sav Blanc please.’ She nods. How the hell she can hear anything over this racket is beyond me. A couple of the guys pivot around and stare.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Very nice.’ I hear one of them say.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Do you want to join us, love? My mate’s getting married and we want to give him a good send off. You know, last meal for the condemned man and all that.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I turn and smile as my bucket full of wine arrives on the bar. ‘No thanks.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A bloke pushes in beside me and slaps a tenner on the bar.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Here, let me,’ he says.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘No thank you.’ I look up, he is tall and handsome with a stubble chin and blue eyes. I recognise him as the one who wolf whistled earlier.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘We all thought you looked like a girl who would know the best places to party, so we’ve taken your recommendation.’ I glance over my shoulder to see the short fat one doing his Walter Raleigh act again, with a deep theatrical bow.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Hey watch it mate!’ The stag party must have taken offence to the new boy muscling in. He ignores them.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I hear the door whoosh open and a gaggle of girls fall into the club dressed in smart business attire. Thursday is the new Friday as far as after work drinks is concerned.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Well?’ The barmaid has her hand out poised to take the money. The tall good-looking man beside me smiles.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Well?’ He flashes his white teeth and the lines around his eyes crease.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Thank you,’ I say picking up the glass and taking a sip.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Make it two, can you love?’ he says to the bored barmaid who’s seen this happen a hundred times a night.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘My name’s Josh.’ He holds out his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Hi,’ I say placing my hand in his. He wraps his strong fingers around mine and gently squeezes. His skin is soft and cool. His aftershave has faded but the remnants of the musky smell wrap around me.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Get in there Joshua my son!’ A voice behind bellows out above the beat of the music, followed by gales of laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I think your friends are missing you.’ I look up, taking another sip.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Nah, they’re just jealous that’s all.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘One of them has an interesting line of chat.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Pete is a bit of a dick when it comes to women, that’s why he’s never had one.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Josh is still holding onto my hand, I make no attempt to pull it away.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Do you buy drinks for every girl you meet on the street, Josh?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘No, just the pretty ones.’ His eyes crease again and his face lights up. He finally releases his grip and my hand falls away. The other drink is slid in front of us on a paper placemat. He picks it up and we chink glasses.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Cheers,’ he says.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Cheers.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Here’s to pretty girls and noisy clubs.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I smile and bat my long eyelashes. The wine is cold against my lips.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("There is a commotion to the side and Josh is shoved into me. In the collision I spill my drink down his shirt.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘What the fuck.’ Josh holds me tight as the fracas continues. The man in the pink tutu clatters to the floor along with a tray of drinks. A star burst of glass erupts into the air showering my feet with beer. The doors fly open and within seconds the bouncers step in.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Come on boys, he’s had enough.’ The tall one lifts the man to his feet and escorts him out, surrounded by his so-called friends.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You okay?’ Josh still has me in his arms.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m fine, just got wet feet that’s all.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("We part and he looks down and laughs. ‘You have as well.’ We are both stood in a puddle, my stockings are discoloured from the liquid. I place my hand against the wet patch on his chest.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I spilled my wine.’ I can feel the muscles in his chest harden against my touch. He places his hand on top of mine.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘That’s fine.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I gaze into his eyes. He is beautiful, with his gelled hair and groomed features. He presses my hand into his body. I look down and can see a faint white band circling the third finger on his left hand. Perfect.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I didn’t catch your name,’ he says.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I didn’t give it.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘My mum told me it was rude to drink with girls when you don’t know their name.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Your mum was right.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘So, we’ve not been properly introduced?’ Josh offers his other hand. I take it and once again feel his cool skin against mine. ‘So?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘So what?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘What’s your name?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You can call me Madeline.’")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8418888","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vol001chapter009.vue
// module id = 102
// module chunks = 0